import React, { useEffect, useRef, useState } from "react";
import "./component.css";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

function Header() {

  const location = useLocation();
  const getActiveTab = () => {
    switch (location.pathname) {
      case "/":
        return 1;
      case "/aboutus":
        return 2;
      case "/courses":
        return 3;
      case "/contactus":
        return 4;
      default:
        return 0;
    }
  };

  const [active, setActive] = useState(getActiveTab());
  const [showMore, setShowMore] = useState(false);

  const handletab = (activeTab) => {
    setActive(activeTab);
  };

  const menuRef = useRef(null); // Create a ref for the menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      console.log("isnide handleclick outside");
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMore(false); // Set showMore to false if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setActive(getActiveTab());
  }, [location.pathname]);

  return (
    <div data-aos="fade-down" className="container headercontainer">
      <Link to={'/'}>
        <img
          src="/assets/img/edraaklogo.png"
          alt="Edraak Logo"
          className="edraaklogo"
        />
      </Link>

      <div className="navcontainer">
        <Link
          to="/"
          className={`nav-item ${active === 1 ? "activenav" : ""}`}
          onClick={() => handletab(1)}
        >
          Home
        </Link>
        <Link
          to="/aboutus"
          className={`nav-item ${active === 2 ? "activenav" : ""}`}
          onClick={() => handletab(2)}
        >
          About Us
        </Link>
        {/* <Link
          to="/courses"
          className={`nav-item ${active === 3 ? "activenav" : ""}`}
          onClick={() => handletab(3)}
        >
          Courses
        </Link> */}
        <Link
          to="/contactus"
          className={`nav-item ${active === 4 ? "activenav" : ""}`}
          onClick={() => handletab(4)}
        >
          Contact Us
        </Link>
      </div>

      <div className="d-flex align-items-center gap-3">
        <Link to={"https://app.edraakonline.com/login"} style={{ textDecoration: "none" }}>
          <div className="signupbtn">Sign Up</div>
        </Link>
        <div className="navmobview" ref={menuRef}>
          <div onClick={() => setShowMore((prev) => !prev)} className="">
           {showMore ? 
           <X
              size={25}
            />
            :
            <Menu
              size={25}
            />}
          </div>
          {showMore && (
            <div className="menuexpand" >
              <div className="tabitem">
                <Link
                  to="/"
                  className="nav-item"
                  onClick={() => setShowMore((prev) => !prev)}
                >
                  Home
                </Link>
              </div>
              <div className="tabitem">
                <Link
                  to="/aboutus"
                  className="nav-item"
                  onClick={() => setShowMore((prev) => !prev)}
                >
                  About Us
                </Link>
              </div>
              {/* <div className="tabitem" onClick={() => setShowMore((prev) => !prev)}>
                <Link to="/courses" className="nav-item">
                  Courses
                </Link>
              </div> */}
              <div className="tabitem" onClick={() => setShowMore((prev) => !prev)}>
                <Link to="/contactus" className="nav-item">
                  Contact Us
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
